<div class="create-property">
  <div class="container">
    <div class="create-property-sec">
      <div class="page-title mb-3">
        <h3 class="text-center">Property Information</h3>
      </div>
      <div class="create-property-form">
        <form [formGroup]="propertyForm" (ngSubmit)="saveProperty()">
          <div class="row">
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="name">Property Name</label>
                <input pInputText class="w-100" id="name" formControlName="name" type="text" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="description">Domain</label>
                <input pInputText class="w-100" id="domain" formControlName="domain" type="text" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="description">Timezone</label>
                <input pInputText class="w-100" id="timezone" formControlName="timezone" type="text" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="address">Address</label>
                <input pInputText class="w-100" id="address" formControlName="address" type="text" />
              </div>
            </div>

            <div class="col-6">
              <div class="form-group mb-2">
                <label for="phone">Textbot Number: (For Leads)</label>
                <input pInputText class="w-100" id="phone" formControlName="phone" type="tel" placeholder="xxx-xxx-xxxx" mask="000-000-0000"/>
                <div class="error text-danger" *ngIf="propertyForm.controls['phone'].invalid && propertyForm.controls['phone'].touched">
                  <small class="text-danger" *ngIf="propertyForm.get('phone')?.errors?.['required']">Phone Number is required.</small>
                  <small class="text-danger" *ngIf="propertyForm.get('phone')?.errors?.['invalidUSPhone']">
                    Kindly provide a valid US phone number in this formats:
                    <code>000-000-0000</code>
                    with a valid US area code.
                  </small>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="activeTwilioNumber">Broadcast Number: (For Tenants)</label>
                <input pInputText class="w-100" id="activeTwilioNumber" formControlName="activeTwilioNumber"
                  type="tel" placeholder="xxx-xxx-xxxx" mask="000-000-0000" />
                <div class="error text-danger"
                  *ngIf="propertyForm.controls['activeTwilioNumber'].invalid && propertyForm.controls['activeTwilioNumber'].touched">
                  <small>Please enter a valid US phone number (xxx-xxx-xxxx).</small>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="email">Email For Email Responder <small class="text-muted">(optional)</small></label>
                <input pInputText class="w-100 readonly-field" id="email" formControlName="email"
                  type="email" placeholder="jeremy@petrieai.com" readonly />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="emailAppPassword">App Password For Email Responder <small class="text-muted">(optional)</small></label>
                <input pInputText class="w-100 readonly-field" id="emailAppPassword" formControlName="emailAppPassword"
                  type="password" placeholder="**** **** **** ****" readonly />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group mb-2">
                <label for="bufferTime">Buffer Time</label>
                <input pInputText class="w-100" id="bufferTime" formControlName="bufferTime" type="number" step="0.5" min="1" max="12" placeholder="4"/>
                <small class="text-danger" *ngIf="propertyForm.get('bufferTime')?.invalid && (propertyForm.get('bufferTime')?.touched || propertyForm.get('bufferTime')?.dirty)">
                  Buffer time must be in increments of 0.5 (e.g., 1, 1.5..)
                </small>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group mb-2">
                <label for="preBookConfirmationHours">Pre-Book Confirmation Hours <span class="text-muted">(optional)</span></label>
                <input pInputText class="w-100" id="preBookConfirmationHours" formControlName="preBookConfirmationHours" type="number" min="1" placeholder="5"/>
                <small class="text-muted">Hours before the 48h window to send confirmation SMS (default: 5)</small>
                <small class="text-danger" *ngIf="propertyForm.get('preBookConfirmationHours')?.invalid && (propertyForm.get('preBookConfirmationHours')?.touched || propertyForm.get('preBookConfirmationHours')?.dirty)">
                  Must be at least 1 hour
                </small>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group mb-2">
                <label for="preBookCancelHours">Pre-Book Cancel Hours <span class="text-muted">(optional)</span></label>
                <input pInputText class="w-100" id="preBookCancelHours" formControlName="preBookCancelHours" type="number" min="1" placeholder="1"/>
                <small class="text-muted">Hours before the 48h window to auto-cancel if no reply (default: 1)</small>
                <small class="text-danger" *ngIf="propertyForm.get('preBookCancelHours')?.invalid && (propertyForm.get('preBookCancelHours')?.touched || propertyForm.get('preBookCancelHours')?.dirty)">
                  Must be at least 1 hour
                </small>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group mb-2">
                <label for="modelUnit">Model Unit</label>
                <p-dropdown
                  id="modelUnit"
                  class="w-100"
                  formControlName="modelUnit"
                  [options]="modelUnitOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select Model Unit">
                </p-dropdown>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group mb-2">
                <label>Resident Availability Filtering</label>
                <p class="text-muted small mb-1">When enabled, tour slots are intersected with resident schedules.</p>
                <p-inputSwitch formControlName="residentFilteringEnabled"></p-inputSwitch>
              </div>
            </div>

            <ng-container *ngIf="property?.yardi_property_id">
              <div class="col-6">
                <div class="form-group mb-2">
                  <label>Yardi Guest Card Pull</label>
                  <p class="text-muted small mb-1">When enabled, guest cards are pulled from Yardi for this property.</p>
                  <p-inputSwitch formControlName="yardi_guest_card_pull"
                    (onChange)="onYardiToggleChange('yardi_guest_card_pull', $event.checked)">
                  </p-inputSwitch>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-2">
                  <label>Yardi Guest Card Push</label>
                  <p class="text-muted small mb-1">When enabled, tour states are pushed to Yardi as guest card events for this property.</p>
                  <p-inputSwitch formControlName="yardi_guest_card_push"
                    (onChange)="onYardiToggleChange('yardi_guest_card_push', $event.checked)">
                  </p-inputSwitch>
                </div>
              </div>
            </ng-container>

          <div class="col-12">
            <div class="col-12">
              <div class="form-group">
                <label for="description">Description</label>
                <textarea id="description" pInputTextarea name="description" formControlName="description" class="form-control"></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group mb-2">
                <label for="chatbot_script">Chatbot Script</label>
                <div class="code-wrapper">
                  <button type="button" class="copy-btn" (click)="copyCode()">
                    <i class="pi" [ngClass]="isCopied ? 'pi-check' : 'pi-copy'"></i>
                    {{ isCopied ? 'Copied!' : 'Copy' }}
                  </button>
                  <pre id="chatbot_script" class="code-box">{{ propertyForm.get('chatbot_script')?.value }}</pre>
                </div>
                </div>
              </div>
            <div class="sgt-section-card" formGroupName="selfGuidedTour">

              <div class="sgt-toggle-row">
                <div>
                  <label class="sgt-toggle-label">Enable Self-Guided Tour</label>
                  <p class="sgt-toggle-sub">Allow visitors to self-schedule tours via an external booking link.</p>
                </div>
                <p-inputSwitch formControlName="enabled"></p-inputSwitch>
              </div>

              <ng-container *ngIf="selfGuidedForm.get('enabled')?.value">
                <hr class="sgt-divider">
                <p class="sgt-section-title">Tour Details</p>

            <div class="row">
              <div class="col-6">
                <div class="form-group mb-2">
                  <label class="d-flex justify-content-between">
                    <span>Left Tour Title <span class="text-danger">*</span></span>
                    <small class="text-muted">{{ selfGuidedForm.get('title')?.value?.length || 0 }}/50</small>
                  </label>
                  <input pInputText class="w-100" formControlName="title" placeholder="e.g. Schedule a Self-Guided Tour" maxlength="50" />
                  <small class="text-danger" *ngIf="selfGuidedForm.get('title')?.touched && selfGuidedForm.get('title')?.hasError('required')">Title is required.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('title')?.hasError('maxlength')">Maximum 50 characters.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('title')?.hasError('specialChars')">Special characters (# $ % ^ * &#64; ~ etc.) are not allowed.</small>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-2">
                  <label>External Booking URL <span class="text-danger">*</span></label>
                  <input pInputText class="w-100" formControlName="externalBookingUrl" placeholder="https://booking.example.com" />
                  <small class="text-danger"
                    *ngIf="selfGuidedForm.get('externalBookingUrl')?.touched && selfGuidedForm.get('externalBookingUrl')?.hasError('required')">
                    URL is required.
                  </small>
                  <small class="text-danger"
                    *ngIf="selfGuidedForm.get('externalBookingUrl')?.touched && selfGuidedForm.get('externalBookingUrl')?.hasError('invalidUrl')">
                    Please enter a valid URL (e.g. https://example.com).
                  </small>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-2">
                  <label class="d-flex justify-content-between">
                    <span>Left / Description <span class="text-danger">*</span></span>
                    <small class="text-muted">{{ selfGuidedForm.get('description')?.value?.length || 0 }}/256</small>
                  </label>
                  <textarea pInputTextarea class="w-100" formControlName="description" rows="3" maxlength="256"
                    placeholder="Describe the self-guided tour experience..."></textarea>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('description')?.touched && selfGuidedForm.get('description')?.hasError('required')">Description is required.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('description')?.hasError('maxlength')">Maximum 256 characters.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('description')?.hasError('specialChars')">Special characters (# $ % ^ * &#64; ~ etc.) are not allowed.</small>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-2">
                  <label class="d-flex justify-content-between">
                    <span>Right Title <span class="text-danger">*</span></span>
                    <small class="text-muted">{{ selfGuidedForm.get('internalTitle')?.value?.length || 0 }}/50</small>
                  </label>
                  <input pInputText class="w-100" formControlName="internalTitle" placeholder="Internal reference title" maxlength="50" />
                  <small class="text-danger" *ngIf="selfGuidedForm.get('internalTitle')?.touched && selfGuidedForm.get('internalTitle')?.hasError('required')">Internal title is required.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('internalTitle')?.hasError('maxlength')">Maximum 50 characters.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('internalTitle')?.hasError('specialChars')">Special characters (# $ % ^ * &#64; ~ etc.) are not allowed.</small>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-2">
                  <label class="d-flex justify-content-between">
                    <span>Right Description <span class="text-danger">*</span></span>
                    <small class="text-muted">{{ selfGuidedForm.get('internalDescription')?.value?.length || 0 }}/256</small>
                  </label>
                  <textarea pInputTextarea class="w-100" formControlName="internalDescription" rows="3" maxlength="256"
                    placeholder="Internal notes or description..."></textarea>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('internalDescription')?.touched && selfGuidedForm.get('internalDescription')?.hasError('required')">Internal description is required.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('internalDescription')?.hasError('maxlength')">Maximum 256 characters.</small>
                  <small class="text-danger" *ngIf="selfGuidedForm.get('internalDescription')?.hasError('specialChars')">Special characters (# $ % ^ * &#64; ~ etc.) are not allowed.</small>
                </div>
              </div>

              <!-- Preview box -->
              <div class="col-12">
                <p class="sgt-section-title mt-2">Preview</p>
                <div class="sgt-preview">
                  <div class="row">
                    <div class="col-6">
                      <div class="sgt-preview__tour-type">
                        <!-- <p class="sgt-preview__type-label">Tour Type</p> -->
                        <div class="sgt-preview__card">
                          <div class="sgt-preview__card-icon">
                            <i class="pi pi-map"></i>
                          </div>
                          <div>
                            <p class="sgt-preview__card-title">{{ selfGuidedForm.get('title')?.value || 'Tour title will appear here' }}</p>
                            <p class="sgt-preview__card-sub">{{ selfGuidedForm.get('description')?.value || 'Tour description will appear here.' }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="sgt-preview__info">
                        <a class="sgt-view-btn"
                          [attr.data-label]="selfGuidedForm.get('internalTitle')?.value || 'View Self-Guided Tour Times'"
                          [href]="selfGuidedForm.get('externalBookingUrl')?.value"
                          target="_blank" rel="noopener noreferrer">
                          <i class="pi pi-chevron-right"></i>
                        </a>
                        <span *ngIf="!selfGuidedForm.get('externalBookingUrl')?.value" class="sgt-view-btn sgt-view-btn--disabled">
                          View Self-Guided Tour Times <i class="pi pi-chevron-right"></i>
                        </span>
                        <p class="sgt-preview__info-desc">
                          {{ selfGuidedForm.get('internalDescription')?.value || 'Self-guided tour availability is managed through our secure tour partner' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <!-- <div class="col-6">
              <div class="form-group mb-2">
                <label for="activeTwilioNumber">Active Twilio Number for Broadcast Messages</label>
                <input pInputText class="w-100" id="activeTwilioNumber" formControlName="activeTwilioNumber" type="tel" placeholder="xxx-xxx-xxxx" mask="000-000-0000"/>
                <div class="error text-danger" *ngIf="propertyForm.controls['activeTwilioNumber'].invalid && propertyForm.controls['activeTwilioNumber'].touched">
                  <small class="text-danger" *ngIf="propertyForm.get('activeTwilioNumber')?.errors?.['required']">Twilio Number is required.</small>
                  <small class="text-danger"  *ngIf="propertyForm.get('activeTwilioNumber')?.errors?.['invalidUSPhone']">
                    Kindly provide a valid US phone number in this formats:
                    <code>000-000-0000</code>
                    with a valid US area code.
                  </small>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-12">
              <div class="form-group p-field mb-2">
                <label for="description">Description</label>
                <textarea pTextarea class="w-100" id="description" formControlName="description"></textarea>
              </div>
            </div> -->
            
            </div>
          </ng-container>

        </div>
            
            </div>


            <!-- <div class="col-12">
              <div class="form-group mb-2">
                <label for="faq">FAQ (Frequently Asked Questions)</label>
                <textarea pInputTextarea class="w-100" id="faq" formControlName="faq" rows="20"></textarea>
              </div>
            </div> -->




            <div class="col-12">
              <div class="btn-container d-flex justify-content-end">
                <p-button type="submit" class="secondary-btn" [disabled]="propertyForm.invalid">Update Property Info</p-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
